import Grid from "@mui/material/Grid";
import {useMemo, useState, useEffect} from "react";
import MySelect from "../../components/MySelect";
import MySearchField from "../../components/MySearchField";
import {USER_TYPE_IDS} from "../../constants";
import {useBusinessUnitCodes} from "../../hooks/useBusinessUnitCodes";
import {useCurrentUser} from "../../hooks/useCurrentUser";
import {useUserTypes} from "../../hooks/useUserTypes";
import {useSalesRegions} from "../../hooks/useSalesRegions";
import {useSalesTerritories} from "../../hooks/useSalesTerritories";

const activatedOptions = [
    {id: "", name: "-- CLEAR --"},
    {id: true, name: "Yes"},
    {id: false, name: "No"},
];

const RepsFilter = ({filter, filterChangeFunctions, setFilter}) => {
    // const [repTypeOptions, setRepTypeOptions] = useState([]);
    const [salesRegionOptions, setSalesRegionOptions] = useState([]);
    const [salesTerritoryOptions, setSalesTerritoryOptions] = useState([]);

    const [currentUser, _updateCurrentUser] = useCurrentUser(false);

    const callerUserTypeIds = (currentUser.userTypes || []).map((t) => t.id);
    const showBusinessUnit = callerUserTypeIds.includes(USER_TYPE_IDS.globalAdmin);
    const showSalesRegion = callerUserTypeIds.some((id) =>
        [USER_TYPE_IDS.globalAdmin, USER_TYPE_IDS.businessUnitManager].includes(id)
    );
    const showSalesTerritoryAndUserType = callerUserTypeIds.some((id) =>
        [USER_TYPE_IDS.globalAdmin, USER_TYPE_IDS.businessUnitManager, USER_TYPE_IDS.regionalSalesManager].includes(
            id
        )
    );

    const [businessUnitCodes, setBusinessUnitCodes] = useState([]);

    useBusinessUnitCodes(true, null, (data) => {
        let options = [...data];
        if (options.length > 1) {
            options = [{id: "", name: "-- CLEAR --"}, ...options];
        }
        setBusinessUnitCodes(options);
    });

    const [userTypes] = useUserTypes({
        enabled: !!currentUser?.id,
        managedByUserId: currentUser?.id,
    });

    const userTypeOptions = useMemo(() => {
        if (userTypes.length === 0) {
            return [];
        }
        return [
            {id: "", name: "-- CLEAR --"},
            ...userTypes.map((t) => ({id: t.id, name: t.displayName})),
        ];
    }, [userTypes]);

    useSalesRegions(filter.businessUnitCode, currentUser.id, showSalesRegion, (data) => {
        // Sort by repsCount desc
        data.sort((a, b) => b.repsCount - a.repsCount);

        // Then change name to name (repsCount)
        const updatedData = data.map((item) => ({
            ...item,
            name: `${item.name} (${item.repsCount} ${item.repsCount > 1 ? "users" : "user"})`,
        }));

        let options = [{id: "", name: "-- CLEAR --"}, ...updatedData];
        setSalesRegionOptions(options);
    });

    useSalesTerritories(
        filter.businessUnitCode,
        filter.salesRegion,
        showSalesTerritoryAndUserType,
        (data) => {
            if (data.length > 0) {
                let options = [{id: "", name: "-- CLEAR --"}, ...data];
                setSalesTerritoryOptions(options);
            } else {
                setSalesTerritoryOptions(data);
            }
            // setSalesTerritoryOptions(data);
        }
    );
    return (
        <Grid container rowSpacing={0} columnSpacing={1}>
            <Grid item sm={6} md={4} lg={3} xl={2.4}>
                <MySearchField
                    label="Search"
                    value={filter.searchString}
                    onChange={filterChangeFunctions.searchString}
                />
            </Grid>
            <Grid item sm={6} md={4} lg={3} xl={2.4}>
                <MySelect
                    label="Activated"
                    options={activatedOptions}
                    value={filter.activated}
                    onChange={filterChangeFunctions.activated}
                />
            </Grid>
            {showBusinessUnit && (
                <Grid item sm={6} md={4} lg={3} xl={2.4}>
                    <MySelect
                        key={filter.businessUnitCode}
                        label="Business Unit"
                        options={businessUnitCodes}
                        value={filter.businessUnitCode}
                        autoSelect={true}
                        onChange={(value) => {
                            filterChangeFunctions.businessUnitCode(value);
                        }}
                    />
                </Grid>
            )}
            {showSalesRegion && (
                <Grid item sm={6} md={4} lg={3} xl={2.4}>
                    <MySelect
                        label="Sales Region"
                        options={salesRegionOptions}
                        value={filter.salesRegion}
                        autoSelect={true}
                        onChange={(value) => {
                            filterChangeFunctions.salesRegion(value);
                        }}
                    />
                </Grid>
            )}
            {showSalesTerritoryAndUserType && (
                <Grid item sm={6} md={4} lg={3} xl={2.4}>
                    <MySelect
                        label="Sales Territory"
                        options={salesTerritoryOptions}
                        value={filter.salesTerritory}
                        onChange={filterChangeFunctions.salesTerritory}
                    />
                </Grid>
            )}
            {showSalesTerritoryAndUserType && (
                <Grid item sm={6} md={4} lg={3} xl={2.4}>
                    <MySelect
                        label="User Type"
                        options={userTypeOptions}
                        value={filter.userTypeId}
                        onChange={filterChangeFunctions.userTypeId}
                    />
                </Grid>
            )}
        </Grid>
    );
};

export default RepsFilter;
